<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <notifications></notifications>
    <side-bar :backgroundColor="colorBackground" id="sidebar">
      <mobile-menu></mobile-menu>
      <template v-if="menus.length > 0 && this.userLogged" slot="links">
        <sidebar-item
          v-if="isMenuVisible('/operativa')"
          :hideItem="ocultarItem"
          :link="{
            name: 'Envíos',
            icon: 'nc-icon nc-delivery-fast',
            path: '*',
          }"
        >
          <sidebar-item
            v-if="isMenuVisible('/franquicia/envios')"
            :hideItem="ocultarItem"
            :link="{ name: 'Envíos', path: '/franquicia/envios' }"
          />
          <sidebar-item
            v-if="isMenuVisible('/franquicia/control')"
            :hideItem="ocultarItem"
            :link="{ name: 'Control', path: '/franquicia/control' }"
          />

          <sidebar-item
            v-if="isMenuVisible('/franquicia/rma')"
            :hideItem="ocultarItem"
            :link="{ name: 'RMA', path: '/franquicia/rma' }"
          >
          </sidebar-item>
          <sidebar-item
            v-if="isMenuVisible('/franquicia/envios-agrupados')"
            :hideItem="ocultarItem"
            :link="{
              name: 'Envíos Agrupados',
              path: '/franquicia/envios-agrupados',
            }"
          >
          </sidebar-item>
          <sidebar-item
            v-if="isMenuVisible('/franquicia/incoterms-sended')"
            :hideItem="ocultarItem"
            :link="{
              name: 'Incoterms',
              path: '/franquicia/incoterms-sended',
            }"
          >
          </sidebar-item>
        </sidebar-item>
        <sidebar-item
          v-if="isMenuVisible('/recogidas')"
          :hideItem="ocultarItem"
          :link="{
            name: 'Recogidas',
            icon: 'nc-icon nc-pickup',
            path: '*',
          }"
        >
          <sidebar-item
            v-if="isMenuVisible('/franquicia/recogidas/propias')"
            :hideItem="ocultarItem"
            :link="{ name: 'Propias', path: '/franquicia/recogidas/propias' }"
          />
          <sidebar-item
            v-if="isMenuVisible('/franquicia/recogidas/otras-plazas')"
            :hideItem="ocultarItem"
            :link="{
              name: 'Otras plazas',
              path: '/franquicia/recogidas/otras-plazas',
            }"
          />
          <sidebar-item
            v-if="isMenuVisible('/franquicia/recogidas/partner')"
            :hideItem="ocultarItem"
            :link="{ name: 'Partner', path: '/franquicia/recogidas/partner' }"
          />
          <sidebar-item
            v-if="isMenuVisible('/franquicia/recogidas/partner-programadas')"
            :hideItem="ocultarItem"
            :link="{
              name: 'Partner programadas',
              path: '/franquicia/recogidas/partner-programadas',
            }"
          />
        </sidebar-item>
        <sidebar-item
          v-if="isMenuVisible('/entregas')"
          :hideItem="ocultarItem"
          :link="{
            name: 'Entregas',
            icon: 'nc-icon nc-delivery',
            path: '*',
          }"
        >
          <sidebar-item
            v-if="isMenuVisible('/franquicia/entregas/propias')"
            :hideItem="ocultarItem"
            :link="{ name: 'Propias', path: '/franquicia/entregas/propias' }"
          />
        </sidebar-item>
        <sidebar-item
          v-if="isMenuVisible('/franquicia/kpis')"
          :hideItem="ocultarItem"
          :link="{
            name: 'KPIs',
            icon: 'nc-icon nc-chart-bar-32',
            path: '/franquicia/kpis',
          }"
        />
        <sidebar-item
          v-if="isMenuVisible('/franquicia/incidencias/historico')"
          :hideItem="ocultarItem"
          :link="{
            name: 'Gestión de Incidencias',
            icon: 'nc-icon nc-settings-tool-66',
            path: '/franquicia/incidencias/historico',
          }"
        >
        </sidebar-item>
        <sidebar-item
          v-if="isMenuVisible('/franquicia/expedientes')"
          :hideItem="ocultarItem"
          :link="{
            name: 'Expedientes',
            icon: 'nc-icon nc-single-copy-04',
            path: '*',
          }"
        >
          <sidebar-item
            v-if="isMenuVisible('/franquicia/expedientes/medidas')"
            :hideItem="ocultarItem"
            :link="{
              name: 'Pesos y Medidas',
              path: '/franquicia/expedientes/medidas',
            }"
          />
          <sidebar-item
            v-if="isMenuVisible('/franquicia/expedientes/servicios')"
            :hideItem="ocultarItem"
            :link="{
              name: 'Garantías de servicio',
              path: '/franquicia/expedientes/servicios',
            }"
          />
          <sidebar-item
            v-if="isMenuVisible('/franquicia/expedientes/siniestros')"
            :hideItem="ocultarItem"
            :link="{
              name: 'Siniestros',
              path: '/franquicia/expedientes/siniestros',
            }"
          />
        </sidebar-item>
        <sidebar-item
          v-if="isMenuVisible('/importaciones')"
          :hideItem="ocultarItem"
          :link="{
            name: 'Importaciones',
            icon: 'nc-icon nc-cloud-upload-94',
            path: '*',
          }"
        >
          <sidebar-item
            :hideItem="ocultarItem"
            :link="{ name: 'Envios', path: '/franquicia/importaciones' }"
            v-if="isMenuVisible('/franquicia/importaciones')"
          />

          <sidebar-item
            :hideItem="ocultarItem"
            :link="{ name: 'RMA', path: '/franquicia/importacionesRma' }"
            v-if="isMenuVisible('/franquicia/importacionesRma')"
          />
        </sidebar-item>
        <sidebar-item
          v-if="isMenuVisible('/facturacion')"
          :hideItem="ocultarItem"
          :link="{
            name: 'Facturación',
            icon: 'nc-icon nc-paper-2',
            path: '*',
          }"
        >
          <sidebar-item
            :hideItem="ocultarItem"
            :link="{
              name: 'Control de Valoraciones',
              path: '/franquicia/valoraciones',
            }"
            v-if="isMenuVisible('/franquicia/valoraciones')"
          />
          <sidebar-item
            :hideItem="ocultarItem"
            :link="{ name: 'Albaranes', path: '/franquicia/albaranes' }"
            v-if="isMenuVisible('/franquicia/albaranes')"
          />

          <sidebar-item
            :hideItem="ocultarItem"
            :link="{ name: 'Facturas', path: '/franquicia/facturas' }"
            v-if="isMenuVisible('/franquicia/facturas')"
          />

          <sidebar-item
            :hideItem="ocultarItem"
            :link="{ name: 'Tarifas', path: '/franquicia/tarifas' }"
            v-if="isMenuVisible('/franquicia/tarifas')"
          />

          <sidebar-item
            :hideItem="ocultarItem"
            :link="{
              name: 'Notificaciones',
              path: '/franquicia/notificaciones',
            }"
            v-if="isMenuVisible('/franquicia/notificaciones')"
          />
          <sidebar-item
            :hideItem="ocultarItem"
            :link="{
              name: 'Documentación',
              path: '/franquicia/documentacion',
            }"
            v-if="isMenuVisible('/franquicia/documentacion')"
          />
        </sidebar-item>
        <sidebar-item
          v-if="isMenuVisible('/gestion_de_cartera')"
          :hideItem="ocultarItem"
          :link="{
            name: 'Gestión de Cartera',
            icon: 'nc-icon nc-credit-card',
            path: '*',
          }"
        >
          <sidebar-item
            :hideItem="ocultarItem"
            :link="{ name: 'Efectos', path: '/franquicia/efectos' }"
            v-if="isMenuVisible('/franquicia/efectos')"
          />

          <sidebar-item
            :hideItem="ocultarItem"
            :link="{ name: 'Remesas', path: '/franquicia/remesas' }"
            v-if="isMenuVisible('/franquicia/remesas')"
          />
        </sidebar-item>
        <sidebar-item
          v-if="isMenuVisible('/logistica')"
          :hideItem="ocultarItem"
          :link="{
            name: 'Logística',
            icon: 'nc-icon nc-app',
            path: '*',
          }"
        >
          <sidebar-item
            :hideItem="ocultarItem"
            :link="{
              name: 'Almacenes',
              path: '/logistica/almacenes',
            }"
            v-if="isMenuVisible('/logistica/almacenes')"
          />
          <sidebar-item
            v-if="isMenuVisible('/logistica/articulos')"
            :hideItem="ocultarItem"
            :link="{
              name: 'Artículos',
              path: '/logistica/articulos',
            }"
          >
          </sidebar-item>
          <sidebar-item
            v-if="isMenuVisible('/logistica/kits')"
            :hideItem="ocultarItem"
            :link="{
              name: 'Kits',
              path: '/logistica/kits',
            }"
          >
          </sidebar-item>
          <sidebar-item
            v-if="isMenuVisible('/logistica/ordenes-entrada')"
            :hideItem="ocultarItem"
            :link="{
              name: 'Ordenes entrada',
              path: '/logistica/ordenes-entrada',
            }"
          >
          </sidebar-item>
          <sidebar-item
            v-if="isMenuVisible('/logistica/ordenes-salida')"
            :hideItem="ocultarItem"
            :link="{
              name: 'Ordenes salida',
              path: '/logistica/ordenes-salida',
            }"
          >
          </sidebar-item>
          <sidebar-item
            :hideItem="ocultarItem"
            :link="{
              name: 'Stock',
              path: '/logistica/stock',
            }"
            v-if="isMenuVisible('/logistica/stock')"
          />
          <sidebar-item
            :hideItem="ocultarItem"
            :link="{
              name: 'Historial stock',
              path: '/logistica/stock-history',
            }"
            v-if="isMenuVisible('/logistica/stock-history')"
          />
          <sidebar-item
            v-if="isMenuVisible('/logistica/valoraciones')"
            :hideItem="ocultarItem"
            :link="{
              name: 'Valoraciones',
              path: '/logistica/valoraciones',
            }"
          >
          </sidebar-item>
          <sidebar-item
            v-if="isMenuVisible('/logistica/tarifas')"
            :hideItem="ocultarItem"
            :link="{
              name: 'Tarifas',
              path: '/logistica/tarifas',
            }"
          >
          </sidebar-item>
          <sidebar-item
            :hideItem="ocultarItem"
            :link="{
              name: 'Importaciones',
              path: '/logistica/importaciones',
            }"
            v-if="isMenuVisible('/logistica/importaciones')"
          />
        </sidebar-item>
        <sidebar-item
          v-if="isMenuVisible('/clientes')"
          :hideItem="ocultarItem"
          :link="{
            name: 'Clientes',
            icon: 'nc-icon nc-circle-09',
            path: '*',
          }"
        >
          <sidebar-item
            :hideItem="ocultarItem"
            :link="{
              name: 'Listado de Clientes',
              path: '/franquicia/clientes',
            }"
            v-if="isMenuVisible('/franquicia/clientes')"
          />
        </sidebar-item>
        <sidebar-item
          v-if="isMenuVisible('/franquicia')"
          :hideItem="ocultarItem"
          :link="{
            name: 'Franquicia',
            icon: 'nc-icon nc-single-02',
            path: '*',
          }"
        >
          <sidebar-item
            :hideItem="ocultarItem"
            :link="{ name: 'Mis Datos', path: '/franquicia/misDatos' }"
            v-if="isMenuVisible('/franquicia/misDatos')"
          />

          <sidebar-item
            :hideItem="ocultarItem"
            :link="{ name: 'Usuarios', path: '/franquicia/usuarios' }"
            v-if="isMenuVisible('/franquicia/usuarios')"
          />
        </sidebar-item>
      </template>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>

      <dashboard-content @click="toggleSidebar"> </dashboard-content>

      <content-footer></content-footer>
    </div>
  </div>
</template>
<script>
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import MobileMenu from "./Extra/MobileMenu.vue";
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import "@/assets/css/parcel-icons.css";

// Menús de la última carga correcta (roles.service los guarda al recibirlos)
function menusGuardados() {
  try {
    const menus = JSON.parse(localStorage.getItem("roles-menu"));
    return Array.isArray(menus) ? menus : [];
  } catch (e) {
    return [];
  }
}

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

export default {
  components: {
    TopNavbar,
    ContentFooter,
    DashboardContent,
    MobileMenu,
  },
  data() {
    return {
      ocultarItem: "mostrarme",
      ro: null,
      colorBackground: "oxperta",
      // Se pinta con los guardados mientras llegan los actuales: si la petición
      // falla, el menú no se queda en blanco
      menus: menusGuardados(),
      reintentosMenus: 0,
      userLogged: null,
    };
  },
  computed: {
    menusStatus() {
      return this.$store.state.roles.menus.status;
    },
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    isMenuVisible(route) {
      if (this.userLogged.roles.includes("ADMIN")) return true;
      const item = this.menus.find((item) => item.key == route);
      if (!item) return true;
      if (item.roles.length <= 0) return true;
      if (!this.userLogged.rolesMenu) {
        return false;
      }
      return item.roles.some((elemento) =>
        this.userLogged.rolesMenu.includes(elemento)
      );
    },
    initScrollbar() {
      let docClasses = document.body.classList;
      let isWindows = navigator.platform.startsWith("Win");
      if (isWindows) {
        // if we are on windows OS we activate the perfectScrollbar function
        docClasses.add("perfect-scrollbar-off");
      } else {
        initScrollbar("main-panel");

        docClasses.add("perfect-scrollbar-on");
      }
    },
    onResize() {
      const sidebar = document.getElementById("sidebar");
      if (!sidebar) return;

      const val = sidebar.clientWidth;
      if (val == 70) {
        this.ocultarItem = "ocultarme";
      } else {
        this.ocultarItem = "mostrarme";
      }
    },
    getMenus() {
      this.$store.dispatch("roles/getMenus");
    },
    getCountries() {
      this.$store.dispatch("geoname/getPaises");
    },
  },
  mounted() {
    this.$sidebar.ocultarSideBar();
    /* document.body.classList.toggle('sidebar-mini') */
    this.initScrollbar();
    this.ro = new ResizeObserver(this.onResize);
    let side = document.getElementById("sidebar");
    this.ro.observe(side);
    this.userLogged = JSON.parse(localStorage.getItem("user"));
    this.getMenus();
    this.getCountries();
  },
  beforeUnmount() {
    if (this.ro) {
      this.ro.disconnect();
    }
  },
  watch: {
    menusStatus(val) {
      if (val.loaded) {
        this.menus = this.$store.state.roles.menus.data.franquicia || [];
      } else if (val.error && this.menus.length === 0 && this.reintentosMenus < 2) {
        // Sin menús guardados (primer acceso): se reintenta antes de dejarlo vacío
        this.reintentosMenus++;
        setTimeout(() => {
          if (localStorage.getItem("user")) this.getMenus();
        }, 2000);
      }
    },
  },
};
</script>
<style scoped></style>
